import Login from '@/pages/AuthLogin.vue';
import Register from '@/pages/AuthRegister.vue';
import RegisterByInvitationSuccess from '@/pages/AuthRegisterByInvitationSuccess.vue';
import PasswordChange from '@/pages/AuthPasswordChange.vue';
import PasswordRecovery from '@/pages/AuthPasswordRecovery.vue';

export default [
  {
    path: '/login',
    name: 'auth-login',
    component: Login,
    meta: { needAuth: false, title: 'Вход' },
  },
  {
    path: '/register/:affiliateCode?',
    name: 'auth-register',
    component: Register,
    meta: { needAuth: false, title: 'Регистрация' },
  },
  {
    path: '/register-by-invitation/success',
    name: 'auth-register-by-invitation-success',
    component: RegisterByInvitationSuccess,
    meta: { needAuth: false, title: 'Регистрация' },
  },
  {
    path: '/password-recovery',
    name: 'auth-password-recovery',
    component: PasswordRecovery,
    meta: { needAuth: false, title: 'Восстановление пароля' },
  },
  {
    path: '/password-reset',
    name: 'auth-password-reset',
    component: PasswordChange,
    meta: { needAuth: false, title: 'Восстановление пароля' },
  },
];
